<template>
  <section class="where-we-work" id="where-we-work">
    <div class="container">
      <!-- Title  -->
      <h1 class="title">Dove operiamo?</h1>

      <p class="paragraph">
        La nostra assistenza è disponibile in tutta la regione Marche fino a
        Ravenna in Emilia Romagna, siamo presenti anche in territorio Lombardo
        nella provincia di Milano e Monza Brianza grazie a Climaline srl,
        cliccando sulla regione di competenza potete accedere al sito web.
      </p>

      <div class="working-map d-flex justify-content-center">
        <ItalyMap />
      </div>
    </div>
  </section>
</template>

<script>
import ItalyMap from "../components/ItalyMap.vue";

export default {
  name: "WhereWeWork",
  components: {
    ItalyMap,
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.where-we-work {
  .container {
    .working-map {
      max-width: 100%;
      overflow: hidden;
    }
  }
}
</style>
